import { HttpRequest } from "../utils";
const httpRequest = new HttpRequest();

export const closure = async (data: { lbfAccount: string; accountId: string }) => await httpRequest.put("/api/lbf/account/closure", data);
export const pay = async (data: IForm) => await httpRequest.put("/api/lbf/account/pay", data);
export const get = async (id: string) => await httpRequest.get(`/api/lbf/account/details`, { lbfAccount: id });

type IForm = { lbfAccount: string | undefined; accountId: string | undefined; amount: number | undefined };
